export const namespaced = true;

export const state = {
  tableData: [],
  altTableData: [],
  currentTableObject: {}
};

export const getters = {
  getTableData: state => {
    return state.tableData;
  },
  getAltTableData: state => {
    return state.altTableData;
  },
  getCurrentTableObject: state => {
    return state.currentTableObject;
  }
};

export const mutations = {
  SET_TABLE_DATA(state, payload) {
    state.tableData = payload;
  },
  SET_ALT_TABLE_DATA(state, payload) {
    state.altTableData = payload;
  },
  SET_CURRENT_TABLE_OBJECT(state, payload) {
    state.currentTableObject = payload;
  }
};

export const actions = {};
